import { SvgIconComponent } from '@mui/icons-material';
import { Box, Button, Typography } from "@mui/material";
import './adminconsole.css';
import { useTranslation } from 'react-i18next';
export interface AdminConsoleCardItemProps {
    description: string;
    iconTitle: SvgIconComponent;
    seeMoreAction: any;
    title: string;
}

export const AdminConsoleCardItem = ({ description, iconTitle: IconTitle, seeMoreAction, title, } : AdminConsoleCardItemProps) => {
    const { t } = useTranslation();

    return (
        <Box sx={{
            background: '#FFFFFF 0% 0% no-repeat padding-box',
            border: '1px solid #0000001A',
            borderRadius: '10px',
            height: '135px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between;',
            padding: '16px',
        }}>
            <Box sx={{
                display: 'flex',
                gap: '12px',
            }}>
                <IconTitle sx={{
                    width: '20px',
                    height: '20px',
                    color: '#22638D',
                    alignSelf: 'center',
                }} />
                <Typography sx={{
                    font: 'normal normal 600 18px/27px Segoe UI',
                    color: '#2D2D2D',
                }}>{title}</Typography>
            </Box>
            <Typography sx={{
                font: 'normal normal normal 14px/21px Segoe UI',
                color: '#969696',
            }}>{description}
            </Typography>
            <Button variant="text" className='moreButton' onClick={seeMoreAction} sx={{
                height: '19px',
                font: 'normal normal normal 14px / 21px Segoe UI',
                letterSpacing: '0px',
                color: '#22638D',
                padding: '0px',
                width: 'fit-content',
                opacity: 0.5,
                background: 'none',
                whiteSpaceCollapse: 'preserve',
                ':hover': {
                    color: '#22638D',
                    opacity: 1,
                    background: 'none',
                }
            }}><span>{t("AdminConsole.SEEMORE")}</span> &gt;</Button>
        </Box>
    )
}

